import { Button } from "Components/_Shared/Buttons/Button";
import { DialogModal } from "Components/_Shared/DialogModal";
import type { AgentSummary } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useTakeBackEditAccess } from "./useTakeBackEditAccess";
import { getAgentFullName } from "./utils";

type Props = {
  readonly isOpen: boolean;
  readonly advisor: AgentSummary | null;
  readonly onClose: () => void;
};

export const TakeBackConfirmDialog = ({ isOpen, advisor, onClose }: Props) => {
  const { t } = useResource();
  const { takeBack, isTakingBack } = useTakeBackEditAccess();

  return (
    <DialogModal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      isPending={isTakingBack}
      closeLabel={t(Resources.Common.Cancel)}
      title={t(Resources.AnalysisDetail.Sharing.Confirm.TakeBack.Title)}
      subtitle={t(Resources.AnalysisDetail.Sharing.Confirm.TakeBack.Text, {
        advisorName: advisor ? getAgentFullName(advisor) : "",
        advisorId: advisor?.ssoId ?? "",
      })}
      primaryAction={
        <Button loading={isTakingBack} onClick={() => takeBack({ onSettled: onClose })}>
          {t(Resources.AnalysisDetail.Sharing.TakeOver)}
        </Button>
      }
    />
  );
};
